import React from 'react';


import Animation from "../animation/animation";
import Card from "../card/card";
import ContactForm from "../contact-form/contact-form";
import Grid from "../grid/grid";
import GridLine from "../grid-line/grid-line";
import ProjectSlider from "../project-slider/project-slider";

import './services.scss';

import automationVideo from '../../f/videos/automation.mp4';
import automationCover from '../../f/img/automation.jpg';
import brandingVideo from '../../f/videos/branding.mp4';
import brandingCover from '../../f/img/branding.jpg';
import grafVideo from '../../f/videos/graf.mp4';
import grafCover from '../../f/img/graf.jpg';
import interfaceVideo from '../../f/videos/interface.mp4';
import interfaceCover from '../../f/img/interface.jpg';
import interiorVideo from '../../f/videos/interior.mp4';
import interiorCover from '../../f/img/interior.jpg';
import navigationVideo from '../../f/videos/navigation.mp4';
import navigationCover from '../../f/img/navigation.jpg';
import prVideo from '../../f/videos/pr.mp4';
import prCover from '../../f/img/pr.jpg';
import promVideo from '../../f/videos/prom.mp4';
import promCover from '../../f/img/prom.jpg';
import smmVideo from '../../f/videos/smm.mp4';
import smmCover from '../../f/img/smm.jpg';
import strategiesVideo from '../../f/videos/strategies.mp4';
import strategiesCover from '../../f/img/strategies.jpg';
import urbanVideo from '../../f/videos/urban.mp4';
import urbanCover from '../../f/img/urban.jpg';
import webVideo from '../../f/videos/web.mp4';
import webCover from '../../f/img/web.jpg';



const Services = () => {
  return (
      <React.Fragment>
        <div className="services category-list">
          <div className="services-header">
            <h1 className="services-header__text">Компетенции <br/> Студии Артемия Лебедева</h1>

            <Animation header="aйдентика, архитектура, веб, видео, графдизайн, городская среда, иллюстрации, интерьеры, интерфейсы, книги, логотипы, мобильные приложения, моушн-дизайн, навигация, паттерны, презентации, промдизайн, реклама, шрифты, экстерьеры" />

            <div className="als-text-container">
              <p className="services__text">
                Мы&nbsp;любим и&nbsp;умеем точно решать сложные бизнес-задачи больших компаний и&nbsp;делать лучше повседневную жизнь людей&nbsp;&mdash; с&nbsp;помощью дизайна.
              </p>
            </div>
          </div>
          <div className="services-main">
            <Grid>
              <GridLine>
                <Card
                    url="https://www.artlebedev.ru/automation/"
                    type="video"
                    previewContent={automationVideo}
                    poster={automationCover}
                    title="Автоматизация дизайна и&nbsp;искусственный интеллект"
                    description="Коллаборации с&nbsp;Николаем Ироновым и&nbsp;высокоскоростная верстка макетов. Масштабные дизайн-системы, генераторы баннеров, шаблонизаторы для брендбуков и&nbsp;соцмедиа."
                />
                <Card
                    url="https://www.artlebedev.ru/strategies/"
                    type="video"
                    previewContent={strategiesVideo}
                    poster={strategiesCover}
                    title="Аналитика и стратегии"
                    description="Эффективные коммуникационные, сервисные, рыночные, бренд- и&nbsp;дизайн-стратегии, умная веб-аналитика и&nbsp;исследования рынка."
                />
                <Card
                    url="/services/branding"
                    type="video"
                    previewContent={brandingVideo}
                    poster={brandingCover}
                    title="Брендинг"
                    description="Айдентика, нейминг, брендбуки, бренд-платформы и&nbsp;логотипы. Экспресс-дизайн для стартапов."
                />
                <Card
                    url="/services/urban"
                    type="video"
                    previewContent={urbanVideo}
                    poster={urbanCover}
                    title="Городской дизайн и урбанистика"
                    description="Архитектура и&nbsp;ландшафтный дизайн, арт-объекты, брендинг территорий, дизайн-коды для городов. Оформление фасадов, городская мебель и&nbsp;объекты."
                />
                <Card
                    url="/services/graf"
                    type="video"
                    previewContent={grafVideo}
                    poster={grafCover}
                    title="Графический дизайн и креатив"
                    description="Дизайн и&nbsp;конструктив упаковки для любых товаров, иллюстрации, паттерны, плакаты, шрифты и&nbsp;3D-анимация."
                />
                <Card
                    url="/services/interior"
                    type="video"
                    previewContent={interiorVideo}
                    poster={interiorCover}
                    title="Интерьеры и экстерьеры"
                    description="Дизайн офисных интерьеров, магазинов, выставочных стендов, витрин и&nbsp;вывесок. Экстерьеры огромных заводских помещений и&nbsp;дизайн самых привлекательных городских фасадов."
                />
                <Card
                    url="/services/navigation"
                    type="video"
                    previewContent={navigationVideo}
                    poster={navigationCover}
                    title="Навигационный дизайн"
                    description="Системы навигации, знаки и&nbsp;указатели, карты и&nbsp;схемы для всего: транспорта, парков, торговых центров, офисов, складских центров и&nbsp;медицинских учреждений."
                />
                {/*<Card*/}
                {/*    url="/services/pr"*/}
                {/*    type="video"*/}
                {/*    previewContent={prVideo}*/}
                {/*    poster={prCover}*/}
                {/*    title="Продвижение и пиар"*/}
                {/*    description="Медийные и&nbsp;креативные стратегии, рекламные интеграции с&nbsp;блогерами, таргетированная реклама в&nbsp;диджитале и&nbsp;соцмедиа, пиар-поддержка."*/}
                {/*/>*/}
                <Card
                    url="/services/prom"
                    type="video"
                    previewContent={promVideo}
                    poster={promCover}
                    title="Промышленный дизайн"
                    description="Промышленный и&nbsp;продуктовый дизайн разных товаров, мебели, аксессуаров, оборудования, электротехники, транспорта, городских и&nbsp;уличных объектов."
                />
                <Card
                    url="/services/interface"
                    type="video"
                    previewContent={interfaceVideo}
                    poster={interfaceCover}
                    title="Приложения и интерфейсы"
                    description="Мобильные приложения, интерфейсы информационных систем, банкоматов и&nbsp;терминалов, эйар-, виар-приложения, UI/UX дизайн."
                />
                <Card
                    url="/services/web"
                    type="video"
                    previewContent={webVideo}
                    poster={webCover}
                    title="Сайты"
                    description="Промо-сайты и&nbsp;лендинги, интерактивные, корпоративные сайты, сервисы, интранеты и&nbsp;интернет-магазины"
                />
                {/*<Card*/}
                {/*    url="/services/smm"*/}
                {/*    type="video"*/}
                {/*    previewContent={smmVideo}*/}
                {/*    poster={smmCover}*/}
                {/*    title="СММ и контент"*/}
                {/*    description="Стратегии ведения аккаунтов и&nbsp;автоматизация шаблонов, подборка авторов и&nbsp;копирайтинг, визуальный контент и&nbsp;оформление страниц в&nbsp;соцмедиа."*/}
                {/*/>*/}
              </GridLine>
            </Grid>
          </div>
          <ProjectSlider />
          {/*<Animation type="words" />*/}
          <ContactForm formId="другое"/>
        </div>
      </React.Fragment>
  );
}

export default Services;
